//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DpSeparator from '../content/Separator.vue';
import DpSpinnerLoader from './SpinnerLoader.vue';

export default {
  name: 'DpSectionLoader',
  components: {
    DpSeparator,
    DpSpinnerLoader,
  },
  props: {
    active: { type: Boolean, default: true },
    size: { type: String, default: 'normal' },
  },
  computed: {
    spinnerSize() {
      switch (this.size) {
        case 'small': return 'normal';
        case 'normal': return 'large';
        case 'large': return 'large';
        default: return 'large';
      }
    },
  },
};
